import * as authTypes from "../types/auth";

export const actionLoginUser = (data) => (dispatch) => {
  dispatch({
    type: authTypes.SAVE_LOGIN_OBJ,
    payload: data,
  });
};

export const actionLogoutUser = () => (dispatch) => {
  dispatch({
    type: authTypes.USER_LOGGED_OUT,
  });
};
